let payMixin = {
  methods: {
    /**
     * 微信公众号支付
     * @param params 微信js api 参数
     */
    weiXinJsApi(params) {
      return new Promise((resolve, reject) => {
        let vm = this;
        //调用微信JS api 支付
        function jsApiCall() {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.invoke("getBrandWCPayRequest", params, function(res) {
            console.log("支付进行中");
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              // 支付成功
              resolve();
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              // 支付取消
              vm.$dialog.toast({
                mes: "支付取消"
              });
              reject();
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
              // 支付失败
              vm.$dialog.toast({
                mes: "支付失败"
              });
              reject();
            }
          });
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", jsApiCall);
            document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
          }
        } else {
          jsApiCall();
        }
      });
    }
  }
};

export default payMixin;
